import React from "react";
import wabtec from "./assets/wabtec.webp";
import hks from "./assets/hks.webp";
import pfizer from "./assets/pfizer.webp";
import RioTinto from "./assets/RioTinto.webp";
import parker from "./assets/parker.webp";

import logo0 from "./assets/home-revamp/marquee-logo/0.png";
import logo1 from "./assets/home-revamp/marquee-logo/1.png";
import logo2 from "./assets/home-revamp/marquee-logo/2.png";
import logo3 from "./assets/home-revamp/marquee-logo/3.png";
import logo4 from "./assets/home-revamp/marquee-logo/4.png";
import logo5 from "./assets/home-revamp/marquee-logo/5.png";
import logo6 from "./assets/home-revamp/marquee-logo/6.png";

const IndexHome7 = () => {
  const companies = [
    {
      image: wabtec,
      name: "Wabtec",
    },
    {
      image: hks,
      name: "HKS",
    },
    {
      image: pfizer,
      name: "Pfizer",
    },
    {
      image: RioTinto,
      name: "Rio Tinto",
    },
    {
      image: parker,
      name: "Parker",
    },
    {
      image: logo0,
      name: "logo0",
    },
    {
      image: logo1,
      name: "logo1",
    },
    {
      image: logo2,
      name: "logo2",
    },
    {
      image: logo3,
      name: "logo3",
    },
    {
      image: logo4,
      name: "logo4",
    },
    {
      image: logo5,
      name: "logo5",
    },
    {
      image: logo6,
      name: "logo6",
    }
  ];
  return (
    <div className="mx-auto flex flex-col items-center px-10 max-w-480:px-4 max-w-480:pt-12 h-full w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
      <div className="bg-white">
        <p className="text-[16px] text-center">Trusted by Leading Organizations</p>
        <div className="relative space-y-2 min-h-[200px] max-w-480:min-h-[140px] w-[80vw] min-2560:w-[60vw] max-w-480:w-[90vw] mt-12 h-full">
          <div className="pointer-events-none absolute top-0 left-0 max-w-480:-left-1 xl:-left-1 min-1440:-left-1 w-16 z-10 h-full bg-gradient-to-r from-white to-transparent" />
          <div className="pointer-events-none absolute -top-1 right-0 max-w-480:-right-1 xl:-right-1 min-1440:-right-1 w-16 z-10 h-full bg-gradient-to-l from-white to-transparent" />

          <div className="overflow-hidden">
            <div className="w-full inline-flex flex-nowrap">
              <ul className="gap-4 flex items-center justify-center md:justify-start [&_li]:mx-4 [&_img]:max-w-none animate-infinite-scroll-right">
                {companies.map((company, index) => (
                  <li key={index}>
                    <img
                      src={company.image}
                      alt={company.name}
                      className="w-40 object-contain grayscale"
                    />
                  </li>
                ))}
                {companies.map((company, index) => (
                  <li key={`duplicate-${index}`}>
                    <img
                      src={company.image}
                      alt={company.name}
                      className="w-40 object-contain grayscale"
                    />
                  </li>
                ))}
              </ul>
              <ul
                className="gap-4 flex items-center justify-center md:justify-start [&_li]:mx-4 [&_img]:max-w-none animate-infinite-scroll-right"
                aria-hidden="true"
              >
                {companies.map((company, index) => (
                  <li key={index}>
                    <img
                      src={company.image}
                      alt={company.name}
                      className="w-40 object-contain grayscale"
                    />
                  </li>
                ))}
                {companies.map((company, index) => (
                  <li key={`duplicate-${index}`}>
                    <img
                      src={company.image}
                      alt={company.name}
                      className="w-40 object-contain grayscale"
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexHome7;
